import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import classnames from 'classnames';
import { ValidatedInput } from "../../Input/ValidatedInput/ValidatedInput";
import { ZipTextPrice } from "../ZipTextPrice/ZipTextPrice";
import { Theme } from "../../Background/Theme/Theme";
import styles from "./PricingForm.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PricingForm = function PricingForm(_ref) {
  var className = _ref.className,
    isOpen = _ref.isOpen,
    pricing = _ref.pricing,
    onZipClick = _ref.onZipClick,
    zipClassName = _ref.zipClassName,
    zipButtonClassName = _ref.zipButtonClassName,
    zipAriaLabel = _ref.zipAriaLabel,
    zipTypog = _ref.zipTypog,
    statusMessageClassName = _ref.statusMessageClassName;
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(styles.wrapper, 'pricingForm', className),
    children: [isOpen && (pricing === null || pricing === void 0 ? void 0 : pricing.input) && /*#__PURE__*/_jsx(Theme, {
      theme: "lightBackground",
      children: /*#__PURE__*/_jsx(ValidatedInput, _objectSpread({
        statusMessageClassName: statusMessageClassName,
        inputClassName: styles.zipInput
      }, pricing.input))
    }), (pricing === null || pricing === void 0 ? void 0 : pricing.zipText) && /*#__PURE__*/_jsx("div", {
      className: styles.zipWrapper,
      children: /*#__PURE__*/_jsx(ZipTextPrice, {
        onClick: onZipClick,
        className: zipClassName,
        zipClassName: zipButtonClassName,
        text: pricing.zipText,
        zipOrLocation: pricing.zipOrLocation || '',
        zipAriaLabel: zipAriaLabel,
        typog: zipTypog
      })
    })]
  });
};